module.exports = __webpack_public_path__ + "static/media/cross.0244e914.png";